"use strict"

const PREFIX = 'auth'

export default {
  login(data) {
    return axios.post(`${PREFIX}/login`, data)
  },

  authenticated() {
    return axios.post(`${PREFIX}/authenticated`, {})
  },
}